import statsig from 'statsig-js'
import { UseCaseInteractor } from '../../../kernel/use-case'
import { Job } from '../domain/job'
import { JobRepository } from '../domain/job.repository'

export const getJobByUUIDUseCase: UseCaseInteractor<[jobRepository: JobRepository], [jobUUID: string], Job> =
  (jobRepository: JobRepository) =>
  async (jobUUID: string): Promise<Job> => {
    const isGetDetailJobByNebulaActive = statsig.checkGate('is_get_detail_job_by_nebula_active')

    if (isGetDetailJobByNebulaActive) {
      const [job, customFields] = await Promise.all([
        jobRepository.getJob(jobUUID),
        jobRepository.getJobCustomFields(jobUUID)
      ])

      return { ...job, ...customFields }
    } else {
      return jobRepository.getJobByUUID(jobUUID)
    }
  }
